import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SubjectArea  {
    _originalTypeClassName = "zERP.BO.SubjectArea";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SubjectArea.translate = translateService;
}
this.SubjectGroups = [];
this.Id = null;
this.Code = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Description:any;
SubjectGroups:any;
static setSubjectGroups = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubjectGroups == null) $this.SubjectGroups = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubjectGroups.length > 0) {
                    Domain.SubjectArea.removeSubjectGroups($this, $this.SubjectGroups[0]);
                }

                Domain.SubjectArea.addManySubjectGroups($this, copyItems);
            }
static addManySubjectGroups = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SubjectArea.addSubjectGroups($this, items[i]);
                }
            }
static addSubjectGroups = ($this, item) => {
                if ($this.SubjectGroups == null) $this.SubjectGroups = [];
                if (item == null || $this.SubjectGroups.indexOf(item) > -1) return;
                $this.SubjectGroups.push(item);
if (item.SubjectArea != $this) {
Domain.SubjectGroup.setSubjectArea(item, $this);
}
}
static addRangeSubjectGroups = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SubjectArea.addSubjectGroups($this, item));
            }
static removeSubjectGroups = ($this, item) => {
                if ($this == null || $this.SubjectGroups == null || $this.SubjectGroups.indexOf(item) === -1) return;
                var _index = $this.SubjectGroups.indexOf(item);
                $this.SubjectGroups.splice(_index, 1);
item.SubjectArea = null;
}
static clearSubjectGroups = ($this) => { $this.SubjectGroups = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}